import { connect } from "react-redux";
import { MicroplateReadout2 as Component } from "./MicroplateReadout2";
import { State, OwnProps, MapStateToProps } from "../types";

function mapStateToProps(
  state: State,
  ownProps: OwnProps
): OwnProps & MapStateToProps {
  return {
    ...ownProps,
    wellsColors: state["microplate"]?.wellsColors || {},
  };
}
export const MicroplateReadout2Redux = connect(mapStateToProps)(Component);
